function initEventHighlight(video)
{
    $(video).find('.highlight-btn').on('click', function(ev)
    {
        ev.preventDefault();

        var highlightBtn = $(this);

        var method = 'post';
        var url = highlightBtn.attr('data-highlight-url');

        if(highlightBtn.hasClass('highlighted'))
        {
            method = 'get';
            url = highlightBtn.attr('data-unhighlight-url');
        }

        $.ajax(
        {
            url: url,
            method: method
        }).done(function(data)
        {
            if((data.error == false) && (data.result == 'ok'))
            {
                if(highlightBtn.hasClass('highlighted'))
                {
                    removeHighlightedStatus($('.highlight-btn.highlighted'));
                }
                else
                {
                    removeHighlightedStatus($('.highlight-btn.highlighted'));
                    addHighlightStatus($('.highlight-btn[data-highlight-url="' + url + '"]'));
                }
            }
            else
            {
                alertWeb(data.message, 'error');
            }
        })
        .fail(function()
        {
        });
    });
}

function removeHighlightedStatus(collection)
{
    collection.each(function()
    {
        var highlightBtn = $(this);

        highlightBtn.removeClass('highlighted');
        highlightBtn.find('span').text(highlightBtn.find('span').attr('data-highlight-text'));
        highlightBtn.find('.icon-star').removeClass('icon-star').addClass('icon-star-empty');
    });
}

function addHighlightStatus(collection)
{
    collection.each(function()
    {
        var highlightBtn = $(this);

        highlightBtn.addClass('highlighted');
        highlightBtn.find('span').text(highlightBtn.find('span').attr('data-unhighlight-text'));
        highlightBtn.find('.icon-star-empty').removeClass('icon-star-empty').addClass('icon-star');
    });
}
